import { NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';

import { EpcotConfig } from '@frontend/sports/common/client-config-data-access';
import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { ThemeElevated } from '@frontend/sports/common/ui/shared';
import { SportsThemedCardDirective } from '@frontend/sports/common/ui/sports-themed-card';
import { NOT_APPLICABLE, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { MarketingViewModel } from '@frontend/sports/types/components/marketing';
import { WidgetComponent } from '@frontend/sports/widget/core/feature';
import { DsCard } from '@frontend/ui/card';
import { DeviceService } from '@frontend/vanilla/core';
import { isEmpty } from 'lodash-es';

@Component({
    selector: 'ms-static-teaser-widget',
    templateUrl: './static-teaser-widget.component.html',
    styleUrls: ['./static-teaser-widget.component.scss'],
    imports: [NgOptimizedImage, TrustPipe, DsCard, SportsThemedCardDirective],
})
export class StaticTeaserWidgetComponent extends WidgetComponent<MarketingViewModel> {
    private trackingService = inject(TrackingService);

    trackingSource = 'Static Teaser';

    teaser: MarketingViewModel;
    image?: string;
    isEpcotEnabled = signal(false);
    themeElevated: ThemeElevated = {
        'sportingbet-br': { isElevated: false },
        'betboo-br': { isElevated: false },
    };
    private readonly epcotConfig = inject(EpcotConfig);
    private readonly deviceService = inject(DeviceService);

    isMobile = computed(() => this.deviceService.isMobile);

    constructor() {
        super();
        this.isEpcotEnabled.update(() => this.epcotConfig.isEnabled);
    }

    protected override onData(data: MarketingViewModel): void {
        this.teaser = data;
        if (this.teaser?.imageUrl) {
            this.image = `${this.teaser.imageUrl}?p=width540`;
        }

        this.hasData = !isEmpty(data);
        this.setWidgetLoaded();
    }

    trackBannerClicked(): void {
        this.trackingService.track(trackingConstants.EVENT_CLICKS, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'Teaser Banners',
            [trackingConstants.COMPONENT_LABEL_EVENT]: this.trackingSource,
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: 'teaser',
            [trackingConstants.COMPONENT_URL_CLICKED]: this.teaser.href,
        });
    }
}
